/**
 * PC_EDF_01 importing the api function calls
 */
import { useState, useEffect } from "react";
import { getEducationQualification, getFieldOfStudy, postEmployeeEducationInfo, getEmployeeEducationInfo, getNotificationId } from "../service/DirectorAPI";
import React from "react";
import moment from "moment";
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import $ from 'jquery';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../components/css/Dashboard-styles.css';
import { connect } from 'react-redux';
import { encryptStorage } from '../constant'

/**
 * 
 *  PC_EDF_03
 * CertificateDetails(props) this function return the HTML
 */
function EducationDetail(props) {

    /**
     * PC_EDF_02 Declaring the state variables and objects
     */
    let dataObj = {
        id: "",
        EducationQualification: "select",
        FieldOfStudy: "select",
        InstituteName: "",
        YearOfPassing: "",
        Percentage: "",
        close: false
    };
    const [state, setState] = useState(dataObj);
    let dropDownArrayEducationQualification = [];
    const [arrDropDowneducationqualification, setarrDropDownEducationqualification] = useState(dropDownArrayEducationQualification);
    let dropDownArrayFieldOfStudy = [];
    const [arrDropDownfieldofstudy, setarrDropDownFieldofstudy] = useState(dropDownArrayFieldOfStudy);
    let rejexvalidation = {
        Percentage: ""
    }
    const [rejexMessage, setRejexMessage] = useState(rejexvalidation);

    let oldvalue = {
        EducationQualification: "",
        FieldOfStudy: "",
        InstituteName: "",
        YearOfPassing: "",
        Percentage: "",
    }
    const [Oldvalue, setOldvalue] = useState(oldvalue);
    const [DisableSubmitBtn, setDisableSubmitBtn] = useState(false);
    let validationFields = {
        EducationQualification: "",
        FieldOfStudy: "",
        InstituteName: "",
        YearOfPassing: "",
        Percentage: "",

    }
    const [message, setmessage] = useState(validationFields);
    const [pagemode, setpagemode] = useState("false");
    const [EmpId, setEmpId] = useState(props.empId);
    const [submit, setSubmit] = useState("Save");
    const [notification, setNotification] = useState([]);
    let [success, setSuccess] = useState(false);
    const [hideForm, setHideForm] = useState(true);
    let loginEmpId = encryptStorage.getItem("employeeId")
    let role = encryptStorage.getItem("role")
    const [reportstoId, setReportstoId] = useState("");
    //let minDate = moment("01-01-2000").format("YYYY-MM-DD");

    /**
     * PC_EDF_03
     * useEffect method get invoked and make a selecteditarray() api call in edit mode
     */
    useEffect(() => {

        if (props.IsEducationClick) {
            LoadEducationQualification();
            //LoadFieldOfStudy();
            setHideForm(false);
        }
    }, [props.IsEducationClick]);

    useEffect(() => {

        if (props.IsEducationClick) {

            // let element = document.getElementById("removeScroll");
            // element.classList.add("removeScroll");

            $("body").addClass("removeScroll");

            if (props.empId != undefined) {
                setEmpId(props.empId)
            }
            if (props.Mode != undefined) {
                if (props.Mode == 'Edit') {
                    setpagemode('true')
                    setSubmit('Update')
                } else {
                    setpagemode('false')
                    setSubmit('Save')
                }
            }
            if (props.Id != undefined) {

                let objedit = {

                    emp_id: props.empId,
                    id: props.Id,
                    reports_to: loginEmpId,
                    role: role,
                };

                selecteditarray(objedit);
            }
        }

    }, [props, success])

    /**
     * PC_EDF_04
     * this function get the data from the db and store into the statevariable
     */
    const LoadEducationQualification = async () => {
        let EducationData = {};
        let responsedata = await getEducationQualification(EducationData);
        setarrDropDownEducationqualification(responsedata.data.ResponseData[0]);
    };

    const LoadFieldOfStudy = async (e) => {

        let FieldOfStudyData = { edu_quali_id: e.target.value };
        let responsedata = await getFieldOfStudy(FieldOfStudyData);
        if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData != null && responsedata.data.ResponseData.length != 0 && responsedata.data.ResponseData[0].length != 0) {
            setarrDropDownFieldofstudy(responsedata?.data?.ResponseData[0]);
        } else {
            setarrDropDownFieldofstudy([]);
        }

    };

    const LoadFieldOfStudyEdit = async (educationId) => {
        let FieldOfStudyData = { edu_quali_id: educationId };
        let responsedata = await getFieldOfStudy(FieldOfStudyData);
        setarrDropDownFieldofstudy(responsedata.data.ResponseData[0]);
    };

    /**
     * 
     * PC_EDF_11 setstate the values into the state object
     */
    const OnChangeName = (e) => {
        var regexItem;
        var checkValid;

        if (e.target.name == "Percentage") {
            regexItem = new RegExp("^[0-9]*$");
            checkValid = regexItem.test(e.target.value);
            if (checkValid == false) {
                rejexMessage.Percentage = "Enter a Valid Percentage"
                setRejexMessage({ ...rejexMessage });


            } else {
                rejexMessage.Percentage = ""
                setRejexMessage({ ...rejexMessage });

                if (e.target.value > 100) {
                    rejexMessage.Percentage = "Enter a Valid Percentage"
                    setRejexMessage({ ...rejexMessage });
                } else {
                    rejexMessage.Percentage = ""
                    setRejexMessage({ ...rejexMessage });
                }
            }
        }

        if (e.target.name == 'EducationQualification') {
            state.EducationQualification = e.target.value;
            state.FieldOfStudy = 'select';
            setState({ ...state });
        } else {
            setState({ ...state, [e.target.name]: e.target.value });

        }

        setmessage({ ...message, [e.target.name]: "" });

        // if (e.target.name == 'EducationQualification') {
        //     setState({ ...state, ['FieldOfStudy']: "select" });
        // }
    };

    /**
     * 
     * PC_EDF_10 this function will bind the value into the dropdown field 
     */
    const buildEducationQualification = () => {
        return arrDropDowneducationqualification.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    const buildFieldOfStudy = () => {
        return arrDropDownfieldofstudy.map((value, index) => {
            return <option value={value.id}>{value.name}</option>;
        });
    };

    /**
     * PC_EDF_12
     * this function display the validation message when user submit the form without required fields
     */


    const validation = () => {
        

        if (state.EducationQualification == "select") {

            message.EducationQualification = "Educational qualification is required"
            setmessage({ ...message });
        } else {
            message.EducationQualification = ""
            setmessage({ ...message });

        }
        if (state.FieldOfStudy == "select") {

            message.FieldOfStudy = "Field of study / major is required"
            setmessage({ ...message });

        } else {
            message.FieldOfStudy = ""
            setmessage({ ...message });

        }
        if (state.InstituteName.trim() == "") {

            message.InstituteName = "Institute / school name is required"
            setmessage({ ...message });

        } else {
            message.InstituteName = ""
            setmessage({ ...message });

            let checkregex = OnlyNumberSpecialChar(state.InstituteName)
            if (checkregex) {

                message.InstituteName = "Enter a Valid Institute / school name"
                setmessage({ ...message });
            } else {
                message.InstituteName = ""
                setmessage({ ...message });

            }

        }
        if (state.YearOfPassing == "" || state.YearOfPassing == null) {

            message.YearOfPassing = "Year of passing is required"
            setmessage({ ...message });

        } else {
            message.YearOfPassing = ""
            setmessage({ ...message });

        }
        if (state.Percentage == "") {

            message.Percentage = "Percentage is required"
            setmessage({ ...message });

        } else {
            message.Percentage = ""
            setmessage({ ...message });

        }

    }

    /**
     * PC_EDF_12.1
     * clear the fields when user clicks the cancel and close button
     */
    const cancelClick = () => {

        let valiclearoption = {
            id: "",
            EducationQualification: "select",
            FieldOfStudy: "select",
            InstituteName: "",
            YearOfPassing: "",
            Percentage: ""
        };
        setState(valiclearoption);

        let validationFields = {
            EducationQualification: "",
            FieldOfStudy: "",
            InstituteName: "",
            YearOfPassing: "",
            Percentage: "",

        }

        setmessage(validationFields);
        setarrDropDownFieldofstudy([]);

        props.setIsEducationClicked(false);
        setHideForm(true);
        // let element = document.getElementById("removeScroll");
        // element.classList.remove("removeScroll");
        $("body").removeClass("removeScroll");


    }


    /**
     * PC_EDF_13
     * this function will post the data into the Data Base
     */
    const submitClick = async () => {
        


        try {
              setDisableSubmitBtn(true);
            validation();

            let isRejexValid = true;
            if (rejexMessage.Percentage != "" || message.InstituteName != "" || message.YearOfPassing != "") {
                isRejexValid = false
            } else {
                isRejexValid = true
            }
            /**
             * PC_EDF_13.1
             * this will make a post call to insert the data into the batadase
             */
            let yearofpassing = moment(new Date(state.YearOfPassing));
            let YearOfPassing = yearofpassing.format("YYYY-MM-DD");

            if (pagemode == "false" && isRejexValid == true) {
                if (
                    state.EducationQualification != "" &&
                    state.FieldOfStudy != "" &&
                    state.InstituteName.trim() != "" &&
                    //state.YearOfPassing != "" &&
                    YearOfPassing != "Invalid date" &&
                    YearOfPassing != "" &&
                    YearOfPassing != null &&
                    state.Percentage != ""
                ) {
                    let insertdata = {
                        request_type: "Insert", //
                        emp_id: EmpId, //
                        login_emp_id: loginEmpId, //
                        role: role,//
                        education_qualification: state.EducationQualification,
                        field_of_study: state.FieldOfStudy,
                        institute_name: state.InstituteName,
                        year_of_passing: YearOfPassing,
                        percentage: state.Percentage,

                    };



                    let responsedata = await postEmployeeEducationInfo(insertdata);
                    if (responsedata.data.status == 200) {
                        let valiclearoption = {
                            id: "",
                            EducationQualification: "select",
                            FieldOfStudy: "select",
                            InstituteName: "",
                            YearOfPassing: "",
                            Percentage: ""
                        };
                        setState(valiclearoption);

                        props.setIsEducationClicked(false);
                        props.getEmployeeEducationGrid();
                        cancelClick();
                        props.showToast('Submitted', 'Submitted Succesfully');
                    }

                }
            }
            /**
             * PC_EDF_31.1 if the role is HR Manager the update will made directly with proper payload
             */
            else if (pagemode == "true" && isRejexValid == true) {

                if (((role == "Hr Manager" || role == "Hr") && loginEmpId != EmpId) || (role == "Hr Manager" && loginEmpId == EmpId && reportstoId == loginEmpId)) {
                    if (
                        state.EducationQualification != "" &&
                        state.FieldOfStudy != "" &&
                        state.InstituteName.trim() != "" &&
                        //state.YearOfPassing != "" &&
                        YearOfPassing != "Invalid date" &&
                        YearOfPassing != "" &&
                        YearOfPassing != null &&
                        state.Percentage != ""
                    ) {
                        let updatedata = {
                            request_type: "Update", //
                            emp_id: EmpId, //
                            login_emp_id: loginEmpId, //
                            role: role,//
                            id: state.id,
                            education_qualification: state.EducationQualification,
                            field_of_study: state.FieldOfStudy,
                            institute_name: state.InstituteName,
                            year_of_passing: YearOfPassing,
                            percentage: state.Percentage,

                        };


                        let responsedata = await postEmployeeEducationInfo(updatedata);
                        if (responsedata.data.status == 200) {

                            let valiclearoption = {
                                id: "",
                                EducationQualification: "select",
                                FieldOfStudy: "select",
                                InstituteName: "",
                                YearOfPassing: "",
                                Percentage: "",
                                close: true
                            };
                            setState(valiclearoption);
                            success = true;
                            setSuccess(true);

                            props.setIsEducationClicked(false);
                            props.getEmployeeEducationGrid();
                            cancelClick();
                            props.showToast('Updated', 'Updated Succesfully');

                        }
                    } else { setSuccess(false); }
                    /**
                     * PC_EDF_31.2 if the role is Team Member
                     * dymamically binding the payload object for current and permanent address
                     */

                } else if ((role == "Team Member" || loginEmpId == EmpId) && isRejexValid == true) {
                    if (
                        state.EducationQualification != "" &&
                        state.FieldOfStudy != "" &&
                        state.InstituteName.trim() != "" &&
                        //state.YearOfPassing != "" &&
                        YearOfPassing != "Invalid date" &&
                        YearOfPassing != "" &&
                        YearOfPassing != null &&
                        state.Percentage != ""
                    ) {

                        let newvalue = {
                            education_qualification: state.EducationQualification,
                            field_of_study: state.FieldOfStudy,
                            institute_name: state.InstituteName,
                            year_of_passing: YearOfPassing,
                            percentage: state.Percentage
                        }

                        let oldvalue = {
                            education_qualification: Oldvalue.EducationQualification,
                            field_of_study: Oldvalue.FieldOfStudy,
                            institute_name: Oldvalue.InstituteName,
                            year_of_passing: Oldvalue.YearOfPassing,
                            percentage: Oldvalue.Percentage,
                        }

                        let NewValue = Object.keys(newvalue);
                        let OldValue = Object.keys(oldvalue);

                        let log_data = '{';
                        for (let i = 0; i <= NewValue.length; i++) {
                            if (newvalue[NewValue[i]] != oldvalue[OldValue[i]]) {

                                log_data += '"' + NewValue[i] + '"' + ':' + '"' + "'" + newvalue[NewValue[i]] + "'" + ',' + "'" + oldvalue[OldValue[i]] + "'" + '"' + ',';
                            }
                            if (i == NewValue.length) {

                                log_data = log_data.slice(0, -1);
                                log_data = log_data + "}";
                            }
                        }

                        if (log_data != '{' && log_data != '}') {

                            let logData = JSON.parse(log_data);
                            let updatedata = {
                                request_type: "Update", //
                                emp_id: EmpId, //
                                login_emp_id: loginEmpId, //
                                category_id: state.id,
                                category: "emp_edu_detail",
                                status: "Pending",
                                role: "Team Member",
                                log_data: logData

                            };

                            let emp = [];
                            notification.map((obj, index) => {

                                emp.push(obj.emp_id);
                            });

                            if (Object.keys(logData).length > 0) {
                                let responsedata = await postEmployeeEducationInfo(updatedata);
                                if (responsedata.data.status == 200) {
                                    let profileRequestId = responsedata.data.ResponseData[1];
                                    await NotificationTrigger({ title: "Profile Update", message: 'Profile Request', route: '/profileupdate', state: { state: { profileRequestId: profileRequestId } }, to_employee: emp, by: loginEmpId }, emp, props.websocket)

                                    let valiclearoption = {
                                        id: "",
                                        EducationQualification: "select",
                                        FieldOfStudy: "select",
                                        InstituteName: "",
                                        YearOfPassing: "",
                                        Percentage: ""
                                    };
                                    setState(valiclearoption);
                                    setSuccess(true);
                                    props.setIsEducationClicked(false);
                                    cancelClick();
                                    props.showToast('Profile Request submitted', 'Changes will be reflected after the approval');

                                }
                            }
                        } else { cancelClick(); }
                    } else { setSuccess(false); }


                }
            }
            setDisableSubmitBtn(false);
        } catch (e) {
            setDisableSubmitBtn(false);

        }
    }

    /**
     * 
     * PC_EDF_20
     *  this function get the record from DB and bind into the respective fields
     */
    const selecteditarray = async (objedit) => {
        try {
            let responsedata = await getEmployeeEducationInfo(objedit);

            if (responsedata.data != undefined && responsedata.data != null && responsedata.data.ResponseData[0].length != 0) {

                let yearofpassing = moment(responsedata.data.ResponseData[0][0].year_of_passing)._d;
                let passinfYear = moment(responsedata.data.ResponseData[0][0].year_of_passing);
                let YearOfPassing = passinfYear.format("YYYY-MM-DD");

                let oldvalueobj = {

                    EducationQualification: responsedata.data.ResponseData[0][0].education_qualification,
                    FieldOfStudy: responsedata.data.ResponseData[0][0].field_of_study,
                    InstituteName: responsedata.data.ResponseData[0][0].institute_name,
                    YearOfPassing: YearOfPassing,
                    Percentage: responsedata.data.ResponseData[0][0].percentage
                };
                setOldvalue(oldvalueobj);

                let valiDateobj1 = {
                    id: responsedata.data.ResponseData[0][0].id,
                    EducationQualification: responsedata.data.ResponseData[0][0].education_qualification,
                    FieldOfStudy: responsedata.data.ResponseData[0][0].field_of_study,
                    InstituteName: responsedata.data.ResponseData[0][0].institute_name,
                    YearOfPassing: yearofpassing,
                    Percentage: responsedata.data.ResponseData[0][0].percentage,
                };
                setState(valiDateobj1);

                LoadFieldOfStudyEdit(responsedata.data.ResponseData[0][0].education_qualification);
            }

            // notification 
            let NotaficationData = await getNotificationId(objedit);
            setNotification(NotaficationData.data.ResponseData[0]);
            setReportstoId(NotaficationData?.data?.ResponseData[0][0]?.emp_id);

        } catch (e) {

        }
    };


    return (
        <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }}
            hidden={hideForm}
            //id="EducationalDetailsPopup" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="EducationalDetailsPopupLabel" aria-hidden="true"
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h5 className="modal-title profile-popup-header" id="EducationalDetailsPopupLabel">
                            Educational Details
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => cancelClick()}
                        />
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-6 mb-4">
                                <label htmlFor="dependant-board" className="form-label hive-form-label">
                                    Educational Qualification<span className="hive-form-mandatory">*</span>
                                </label>
                                <select
                                    className="form-select hive-form-select"
                                    aria-label="Default select example"
                                    id="dependant-board"
                                    name="EducationQualification"
                                    value={state.EducationQualification}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                        LoadFieldOfStudy(e);
                                    }}
                                >
                                    <option selected="">select</option>
                                    {buildEducationQualification()}
                                </select>
                                {message.EducationQualification ? (
                                    <label className="hive-form-mandatory">{message.EducationQualification}</label>
                                ) : null}
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="dependant-board" className="form-label hive-form-label">
                                    Field of Study / Major<span className="hive-form-mandatory">*</span>
                                </label>
                                <select
                                    className="form-select hive-form-select"
                                    aria-label="Default select example"
                                    id="dependant-board"
                                    name="FieldOfStudy"
                                    value={state.FieldOfStudy}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                >
                                    <option selected>select</option>
                                    {buildFieldOfStudy()}
                                </select>
                                {message.FieldOfStudy ? <label className="hive-form-mandatory">{message.FieldOfStudy}</label> : null}
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="dependant-institute-location" className="form-label hive-form-label">
                                    Institute / School Name<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    defaultValue="Navalur, Chennai"
                                    className="form-control hive-form-control"
                                    id="dependant-institute-location"
                                    aria-describedby="Institution Location"
                                    placeholder="Enter here"
                                    maxLength={225}
                                    name="InstituteName"
                                    value={state.InstituteName}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.InstituteName ? <label className="hive-form-mandatory">{message.InstituteName}</label> : null}
                            </div>
                            <div className="col-md-3 mb-4">
                                <label htmlFor="dependant-joining-date" className="form-label hive-form-label">
                                    Year of Passing<span className="hive-form-mandatory">*</span>
                                </label>
                                {/* <input type="date" className="form-control hive-form-control" id="dependant-institute-location" aria-describedby="Year of Joining"
                                    name="YearOfPassing" value={state.YearOfPassing} onChange={(e) => { OnChangeName(e); }} /> */}

                                <DatePicker
                                    selected={state.YearOfPassing}
                                    onChange={(e) => {
                                        setState({ ...state, ['YearOfPassing']: e });
                                        setmessage({ ...message, ['YearOfPassing']: '' });
                                    }}
                                    name="YearOfPassing"
                                    showYearPicker
                                    value={state.YearOfPassing}
                                    className="form-control hive-form-control"
                                    dateFormat="yyyy"
                                    placeholderText="Year"
                                    //maxDate={minDate}
                                />

                                {message.YearOfPassing ? <label className="hive-form-mandatory">{message.YearOfPassing}</label> : null}
                            </div>
                            <div className="col-md-3 mb-4">
                                <label htmlFor="dependant-percentage" className="form-label hive-form-label">
                                    Percentage<span className="hive-form-mandatory">*</span>
                                </label>
                                <input
                                    type="text"
                                    defaultValue="81.2%"
                                    className="form-control hive-form-control"
                                    id="dependant-institute-location"
                                    aria-describedby="Percentage"
                                    placeholder="Enter here"
                                    maxLength={3}
                                    name="Percentage"
                                    value={state.Percentage}
                                    onChange={(e) => {
                                        OnChangeName(e);
                                    }}
                                />
                                {message.Percentage ? <label className="hive-form-mandatory">{message.Percentage}</label> : null}
                                {rejexMessage.Percentage ? <label className="hive-form-mandatory">{rejexMessage.Percentage}</label> : null}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn hive-btn-secondary" data-bs-dismiss="modal" onClick={() => cancelClick()}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            id={'EduSubmitBtn'}
                            className="btn hive-btn-primary"
                            onClick={submitClick}
                            disabled={DisableSubmitBtn}
                        >
                            {submit}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(EducationDetail)